import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
    selector: 'app-enterprise-wallet-summary',
    templateUrl: './enterprise-wallet-summary.component.html',
    styleUrls: ['./enterprise-wallet-summary.component.css'],
})
export class EnterpriseWalletSummaryComponent implements OnInit {
    id: string;
    userId: string;
    display = false;
    summary: any;

    sessionUser$ = this.loginService.sessionUser.asObservable();

    constructor(
        private dashboardService: DashboardService,
        public loginService: LoginService,
    ) { }

    ngOnInit() {
        this.sessionUser$
            .pipe(take(1)) // take only once to avoid memory leaks or duplicate requests
            .subscribe((user) => {
                if (user?.enterprise) {
                    this.id = user.enterprise.enterpriseId;
                    this.userId = user.enterprise.userId;
                    this.getWalletSummary();
                }
            });
    }

    getWalletSummary() {

        this.dashboardService.getWalletSummary(this.userId).subscribe(
            (res) => {
                this.summary = res;

                if (!this.summary.reconciliationPassed) {
                    this.display = true;
                }
            },
            (err) => {
            },
        );
    }
}
